// extracted by mini-css-extract-plugin
export default {"terms_container":"styles_terms_container__KCGzG","terms_view":"styles_terms_view__BMkX6","terms_btns":"styles_terms_btns__8CP3f"};